import { render } from "./ButtonGroupActions.vue?vue&type=template&id=6e30bff2"
import script from "./ButtonGroupActions.vue?vue&type=script&lang=ts"
export * from "./ButtonGroupActions.vue?vue&type=script&lang=ts"
script.render = render

export default script